// /pages/web3.tsx

import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useNavigate } from "react-router-dom";
import { toast } from "@/hooks/use-toast";
import { ArrowLeft } from "lucide-react";

export default function Web3() {
  const WALLET_URL = "https://wallet.fixorium.com.pk";

  useEffect(() => {
    window.location.href = WALLET_URL;
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="uppercase text-[10px] text-muted-foreground">
          REDIRECTING TO FIXORIUM WALLET...
        </p>
      </div>
    </div>
  );
}
